<template>
  <div :class="classObj" class="app-wrapper">
    <top-nav />
    <sidebar v-if="false" class="sidebar-container" />
    <!--    <NewSide></NewSide>-->
    <NewSideSecond></NewSideSecond>
    <SearchMenuInput></SearchMenuInput>
    <div class="main-container">
      <!--      <div class="tags-box">-->
      <!--        <tags-view />-->
      <!--      </div>-->
      <!--      <div class="breadcrumb-box">-->
      <!--        <breadcrumb class="breadcrumb-container" />-->
      <!--      </div>-->
      <app-main />
    </div>
    <!--    引导-->
    <template v-if="isLoginNewSys === 'false' && favoriteMenus.length === 0">
      <div class="tips-box"></div>
      <div class="tips-content">
        <img src="@/assets/whitebg.png" class="whitebg" alt="白底" />
        <div class="text-box">
          <div class="triangle-left"></div>
          <img src="@/assets/exImg.png" class="exImg" alt="exImg" />
          可以点击星型图标对常用功能菜单进行收藏！收藏后，可在常用菜单中快速触达!
          <el-button class="know-btn" size="mini" @click="iKnow">我知道了</el-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { AppMain, Sidebar, TopNav, NewSideSecond, SearchMenuInput } from "./components"
// import Breadcrumb from "@/components/Breadcrumb"
import ResizeMixin from "./mixin/ResizeHandler"
// im 相关逻辑
import ImMixin from "./mixin/ImMixin"
import { mapState } from "vuex"

export default {
  name: "Layout",
  components: {
    AppMain,
    Sidebar,
    TopNav,
    // NewSide,
    NewSideSecond,
    SearchMenuInput
    // Breadcrumb
  },
  mixins: [ResizeMixin, ImMixin],
  data() {
    return {
      isLoginNewSys: localStorage.getItem("isLoginNewSys") || "false"
    }
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    ...mapState("tagsView", ["favTopShow"]),
    ...mapState("user", ["favoriteMenus"]),
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        favTopShowClass: this.favTopShow
      }
    }
  },
  mounted() {
    // 默认收起侧边栏，不再展开
    this.handleClickOutside()
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false })
    },
    iKnow() {
      localStorage.setItem("isLoginNewSys", "true")
      this.isLoginNewSys = "true"
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  background: #f0f2f5;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
::v-deep micro-app {
  height: 100%;
}
.tips-box,
.tips-content {
  position: fixed;
  z-index: 9999999999998;
  background: #333333;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.tips-content {
  z-index: 9999999999999 !important;
  background: none !important;
  opacity: 1 !important;
  .arrow {
    width: 60px;
    height: 60px;
    margin-top: 30px;
    margin-left: 50px;
    position: absolute;
  }
  .whitebg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9;
    width: 54px;
  }
  .text-box {
    padding: 20px;
    border-radius: 5ox;
    background: #2d8cf0;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-end;
    margin-left: 80px;
    color: #ffffff;
    font-size: 14px;
    position: relative;
    width: 240px;
    line-height: 24px;
    .exImg {
      width: 200px;
      margin-bottom: 10px;
    }
    .know-btn {
      flex-shrink: 0;
      width: 80px;
      margin-top: 10px;
    }
    .triangle-left {
      position: absolute;
      left: -20px;
      width: 0;
      height: 0;
      border-top: 10px solid transparent; /* 上边框透明 */
      border-right: 20px solid #2d8cf0; /* 右边框红色，形成三角形 */
      border-bottom: 10px solid transparent; /* 下边框透明 */
    }
  }
}
.favTopShowClass .main-container {
  height: calc(100vh - 90px) !important;
  top: 82px !important;
}
.favTopShowClass .app-main {
  height: calc(100% - 11px) !important;
}
</style>
